<template>
	<div class="bc">
		<template v-for="(item, index) in items" :key="item">
			<NuxtLink v-if="index != items.length - 1" :to="item.url_without_domain">
				<span>{{ item.title }}</span>
			</NuxtLink>
			<span v-else class="bc-last">{{ item.title }}</span>
		</template>
	</div>
</template>

<script setup>
	const props = defineProps(['items', 'mode']);
</script>

<style lang="less" scoped>
</style>
